
import Vue from 'vue'

const getDefaultState = () => {
    return {
        vacation: {
            id: 0,
            idServiceProject: 0,
            idProduct: 0,
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async ListByUser(_, idUser) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`hr/vacation/list-by-user/${idUser}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listVacation = result.data.result;

                return listVacation;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list vacation: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`hr/vacation/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error to get vacation`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get vacation: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, vacationRequest) {

        try {

            const result = await Vue.prototype.$vanKirkApi.post(`hr/vacation/create-update`, vacationRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {

                let msg = "Register updated with success!";

                if (vacationRequest.id === 0) {
                    msg = "Record created successfully";
                }

                return {
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to create/update register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },

    async UpdateStatus(_, vacationStatusRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.put(`hr/vacation/update-status/${vacationStatusRequest.id}`, vacationStatusRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {
                return {
                    success: true,
                    message: "Status updated with success!"
                };
            }
            else {
                return {
                    success: false,
                    message: "Error updating the status!"
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error updating the status: [${ex}]`
            };
        }
    },
    
    async ListTypeVacation() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`hr/vacation/list-type-vacation`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listTypeVacation = result.data.result;

                return listTypeVacation;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list vacation type: [${ex}]`
            };
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.vacation, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.vacation;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}